<template>
  <main class="admin-models">
    <div class="admin-models__wrapper">
      <div class="admin-models__controls">
        <div class="admin-models__filters">
          <h1 class="admin-models__page-title">модели</h1>
          <filter-selector
            v-model="selectedFilter"
            :options="filterOptions"
            :name="filterName"
          ></filter-selector>
        </div>
        <div class="admin-models__search">
          <input
            @keyup.prevent.enter="performSearch"
            @input="clearSearch"
            class="admin-models__search-field"
            v-model="searchRequest"
            type="search"
            placeholder="Поиск"
          >
        </div>
      </div>
      <div class="admin-models__models" ref="models">
        <router-link class="new-model" tag="div" :to="{ name: 'AdminModelNew'}">
          <div class="new-model__wrapper">
            <img class="new-model__icon" src="../assets/plus_icon.svg">
            <span class="new-model__title">добавить модель</span>
          </div>
        </router-link>
        <router-link
          class="model-card"
          v-for="model in models"
          :key="model.id"
          tag="div"
          :title="model.name"
          :to="{ name: 'AdminModelEdit', params: { id: model.id ? model.id : model.objectID }}"
        >
          <div class="model-card__image-wrapper">
            <img class="model-card__image" loading="lazy" :src="model.preview.url" :alt="model.name">
            <div class="model-card__overlay"></div>
          </div>
          <span class="model-card__name">{{ model.name }}</span>
        </router-link>
        <div ref="observable"></div>
      </div>
    </div>
  </main>
</template>

<script>
import FilterSelector from '../components/FilterSelector'
import { apiGetModels } from '../utils/api'
import algoliasearch from 'algoliasearch/lite'
import { CHANGE_MODELS_FILTER, SET_ALGOLIA_CLIENT } from '../store/mutations-names'

export default {
  name: 'AdminModels',
  components: {
    FilterSelector
  },
  data() {
    return {
      filterOptions: [
        { name: 'all', value: 'all' },
        { name: 'women', value: 'female' },
        { name: 'men', value: 'male' },
      ],
      filterName: 'filters',
      selectedFilter: this.$store.state.adminModelsFilter,
      searchRequest: '',
      models: [],
      intersectionObserver: null,
      isLoading: false,
      algoliaIndex: null,
      nextPage: 1
    }
  },
  watch: {
    selectedFilter() {
      this.$store.commit(CHANGE_MODELS_FILTER, this.selectedFilter)
      this.loadInitialData()
    }
  },
  mounted() {
    // init aloglia client if not present in vuex
    if (!this.$store.state.adminAlgoliaClient) {
      const client = algoliasearch('C5SVSHCML6', '41121316da18dbc2067de6a69107a5b8')
      this.$store.commit(SET_ALGOLIA_CLIENT, client)
      this.algoliaIndex = client.initIndex('models')
    } else {
      this.algoliaIndex = this.$store.state.adminAlgoliaClient.initIndex('models')
    }
    // setup intersectionObserver
    this.intersectionObserver = new IntersectionObserver(this.loadMoreData, {
      root: null,
      threshold: 0
    })
    this.intersectionObserver.observe(this.$refs.observable)
    // loadInitialData
    this.loadInitialData()
  },
  methods: {
    clearSearch() {
      if (this.searchRequest.length == 0) {
        this.loadInitialData()
      }
    },
    performSearch() {
      // just load data from firestore
      if (this.searchRequest.length == 0) {
        this.loadInitialData()
      } else {
        // perform search and load result
        let filters
        this.selectedFilter == 'all' ? filters = '' : filters = `gender: ${this.selectedFilter}`
        this.algoliaIndex.search(this.searchRequest, { filters })
          .then(({ hits }) => {
            this.models = hits
          })
          .catch((error) => {
            console.error(error)
          })
      }
    },
    async loadInitialData() {
      this.models = []
      this.nextPage = 1
      this.isLoading = true
      try {
        const filter = this.selectedFilter == 'all' ? '' : this.selectedFilter
        let result = await apiGetModels(this.nextPage, filter)
        this.models = result.docs
        if (result.hasNextPage) {
          this.nextPage++
        } else {
          this.nextPage = null
        }
      } catch(e) {
        console.error(e.message)
        this.isLoading = false
      }
      this.isLoading = false
    },
    async loadMoreData(entries) {
      if (this.isLoading || !this.nextPage) {
        return
      }
      this.isLoading = true
      entries.forEach(async (entry) => {
        if (entry.isIntersecting) {
          try {
            const filter = this.selectedFilter == 'all' ? '' : this.selectedFilter
            let result = await apiGetModels(this.nextPage, filter)
            this.models.push(...result.docs)
            if (result.hasNextPage) {
              this.nextPage++
            } else {
              this.nextPage = null
            }
          } catch(e) {
            console.error(e.message)
            this.isLoading = false
          }
          this.isLoading = false
        }
      })
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
@use "../styles/colors";

.admin-models {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 60px 45px 20px;
  &__wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    max-width: 1328px;
  }
  &__controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
  }
  &__page-title {
    display: inline-block;
    margin-right: 35px;
    font-size: 22px;
    text-transform: uppercase;
  }
  &__search-field {
    width: 290px;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #000;
    border-radius: 0;
    font-size: 16px;
    &::placeholder {
      color: colors.$grayb2;
    }
  }
  &__models {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    column-gap: 10px;
    row-gap: 10px;
  }
}

.new-model {
  cursor: pointer;
  &__wrapper {
    position: relative;
    padding-top: 120%;
    background-color: colors.$grayef;
  }
  &__icon {
    position: absolute;
    top: calc(50% - 15px);
    left: calc(50% - 15px);
    width: 30px;
  }
  &__title {
    position: absolute;
    left: calc(50% - 45px);
    bottom: 30%;
    font-size: 10px;
    color: colors.$gray8b;
  }
}

.model-card {
  cursor: pointer;
  &:hover &__overlay {
    opacity: 0.4;
  }
  &__image-wrapper {
    position: relative;
    padding-top: 120%;
    margin-bottom: 10px;
  }
  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: colors.$grayef;
  }
  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: #000;
    transition: 200ms all ease;
  }
  &__name {
    display: block;
    @include fonts.ap-reg;
    font-size: 13px;
    text-transform: uppercase;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

@media screen and (max-width: 1023px) {
  .admin-models {
    padding: 50px 12px 40px;
  }
}

@media screen and (max-width: 860px) {
  .admin-models {
    &__controls {
      display: block;
    }
    &__filters {
      margin-bottom: 15px;
    }
    &__page-title {
      margin-right: 20px;
    }
    &__search-field {
      width: 100%;
    }
    &__models {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    }
  }
}
</style>